<template>
  <div class="control-panel">
    <font-awesome-icon
      icon="times"
      size="2x"
      class="float-right control-btn"
      @click="closePanel()"
    />
    <h4>{{ $t('control') }}</h4>
    <template v-for="(actors, argument) in getGroupedControlActors">
      <argument-control :actors="actors" :argument="argument" :key="argument" />
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ControlPanelMixin from '@/mixins/ControlPanel';
import ArgumentControl from '@/components/service-groups/ArgumentControl.vue';

export default {
  name: 'SelectionControlPanel',
  mixins: [ControlPanelMixin],
  props: {
    servicesIds: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getControlActorsForServiceIds',
    ]),
    getGroupedControlActors() {
      return _.groupBy(
        this.getControlActorsForServiceIds(this.servicesIds),
        'argument',
      );
    },
  },
  components: {
    ArgumentControl,
  },
};
</script>

<style scoped>

</style>
